import { Reducer } from 'redux';
import {
  ContractInformationResponse,
  CreateOrganizationResponse,
  OrganizationResponse,
} from '../.generated/api';

export interface OrganizationState {
  name: string;
  id: string;
  error?: string;
  organization?: OrganizationResponse | null;
  currentContract?: ContractInformationResponse | null;
  nextContract?: ContractInformationResponse | null;
  logo?: string;
}
export interface CreateOrganizationActionSuccess {
  type: 'CREATE_ORGANIZATION_SUCCESS';
  organization: CreateOrganizationResponse;
}

export interface GetOrganizationByIdError {
  type: 'GET_ORGANIZATION_ERROR';
  error: string;
}

export interface GetOrganizationByIdSuccess {
  type: 'GET_ORGANIZATION_SUCCESS';
  organization: OrganizationResponse;
}

export interface CreateOrganizationActionFailure {
  type: 'CREATE_ORGANIZATION_FAILURE';
  error: string;
}
export interface OrganizationResetStateAction {
  type: 'ORGANIZAION_RESET_STATE';
}

export interface CreateOrganizationRemoveErrorAction {
  type: 'ORGANIZATION_REMOVE_ERROR';
}

export interface UpdateOrganizationErrorAction {
  type: 'UPDATE_ORGANIZATION_ERROR';
  error: string;
}

export interface UpdateOrganizationSuccessAction {
  type: 'UPDATE_ORGANIZATION_SUCCESS';
}

export interface UpdateOrganizationLogoAction {
  type: 'UPDATE_ORGANIZATION_LOGO';
  logo?: string;
}

export interface UpdateCurrentContractAction {
  type: 'UPDATE_CURRENT_CONTRACT';
  currentContract?: ContractInformationResponse | null;
}

export interface UpdateNextContractAction {
  type: 'UPDATE_NEXT_CONTRACT';
  nextContract?: ContractInformationResponse | null;
}

type CreateOrganizationActionTypes =
  | CreateOrganizationActionSuccess
  | CreateOrganizationActionFailure
  | OrganizationResetStateAction
  | CreateOrganizationRemoveErrorAction
  | GetOrganizationByIdSuccess
  | GetOrganizationByIdError
  | UpdateOrganizationErrorAction
  | UpdateOrganizationSuccessAction
  | UpdateOrganizationLogoAction
  | UpdateCurrentContractAction
  | UpdateNextContractAction;

const organizationReducer: Reducer<
  OrganizationState,
  CreateOrganizationActionTypes
> = (
  state: OrganizationState | undefined,
  incomingAction: CreateOrganizationActionTypes,
): OrganizationState => {
  if (state === undefined) {
    return { name: '', id: '' };
  }

  switch (incomingAction.type) {
    case 'GET_ORGANIZATION_SUCCESS':
      return {
        ...state,
        error: undefined,
        organization: incomingAction.organization,
      };
    case 'GET_ORGANIZATION_ERROR':
      return {
        ...state,
        error: incomingAction.error,
        organization: null,
      };
    case 'CREATE_ORGANIZATION_SUCCESS':
      return {
        name: incomingAction.organization.name,
        id: incomingAction.organization.id,
      };
    case 'CREATE_ORGANIZATION_FAILURE':
      return {
        ...state,
      };
    case 'UPDATE_ORGANIZATION_ERROR':
      return {
        ...state,
        error: incomingAction.error,
      };
    case 'UPDATE_ORGANIZATION_SUCCESS':
      return {
        ...state,
        error: undefined,
      };
    case 'UPDATE_ORGANIZATION_LOGO':
      return {
        ...state,
        logo: incomingAction.logo,
      };
    case 'UPDATE_CURRENT_CONTRACT':
      return {
        ...state,
        currentContract: incomingAction.currentContract,
      };
    case 'UPDATE_NEXT_CONTRACT':
      return {
        ...state,
        nextContract: incomingAction.nextContract,
      };
    case 'ORGANIZATION_REMOVE_ERROR':
      return {
        ...state,
        error: undefined,
      };
    case 'ORGANIZAION_RESET_STATE':
      return {
        name: '',
        id: '',
      };
    default:
      return state;
  }
};

export { organizationReducer };
